import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $peaceTitleHeading: String,
    $peaceTitleHeading_en: String,
    $peaceTitleHeading_fr: String,
    $peaceTitleHeading_it: String,
    $peaceTitleHeading_pt: String,
    $peaceTitle3: String,
    $peaceTitle3_en: String,
    $peaceTitle3_fr: String,
    $peaceTitle3_it: String,
    $peaceTitle3_pt: String,
    $peaceContent3: String,
    $peaceContent3_en: String,
    $peaceContent3_fr: String,
    $peaceContent3_it: String,
    $peaceContent3_pt: String
) {
  updateWhyHostPage (
    peaceTitleHeading: $peaceTitleHeading,
    peaceTitleHeading_en: $peaceTitleHeading_en,
    peaceTitleHeading_fr: $peaceTitleHeading_fr,
    peaceTitleHeading_it: $peaceTitleHeading_it,
    peaceTitleHeading_pt: $peaceTitleHeading_pt,
    peaceTitle3: $peaceTitle3,
    peaceTitle3_en: $peaceTitle3_en,
    peaceTitle3_fr: $peaceTitle3_fr,
    peaceTitle3_it: $peaceTitle3_it,
    peaceTitle3_pt: $peaceTitle3_pt,
    peaceContent3: $peaceContent3,
    peaceContent3_en: $peaceContent3_en,
    peaceContent3_fr: $peaceContent3_fr,
    peaceContent3_it: $peaceContent3_it,
    peaceContent3_pt: $peaceContent3_pt
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
